const Footer = () => {
  return (
    <footer className="Footer">
      <div>
        Made with React at
        <a
          href="http://www.lereacteur.io"
          target="_blank"
          rel="noopener noreferrer"
        >
          Le Reacteur
        </a>
        by
        <a
          href="http://www.ludovic-six.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          Ludovic Six
        </a>
        - 2021
      </div>
    </footer>
  );
};

export default Footer;
